import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { RouteChangeAction } from './global.actions';
import { ActivationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

@Injectable()
export class GlobalEffects {

  constructor(
    private actions$: Actions,
    private router: Router,
    // private location: Location,
    private store: Store<any>
  ) {
    this.listenToRouter();
  }

  // TODO: After upgrading to Angular 6, see https://medium.com/@amcdnl/angular-routing-data-with-ngrx-effects-1cda1bd5e579
  /*
    @Effect({ dispatch: false })
    navigate$ = this.actions$.pipe(
        ofType('[Router] Go'),
        map((action: RouterGoAction) => action.payload),
        tap(({ path, queryParams, extras }) => this.router.navigate(path, { queryParams, ...extras }))
    );

    @Effect({ dispatch: false })
    navigateBack$ = this.actions$.pipe(ofType('[Router] Back'), tap(() => this.location.back()));

    @Effect({ dispatch: false })
    navigateForward$ = this.actions$.pipe(
        ofType('[Router] Forward'),
        tap(() => this.location.forward())
    );

    private listenToRouter() {
        this.router.events.pipe(
            filter(event => event instanceof ActivationEnd)
        ).subscribe((event: ActivationEnd) =>
            this.store.dispatch(new RouteChangeAction({
                params: { ...event.snapshot.params },
                path: event.snapshot.routeConfig.path
            }))
        );
    }
    */

  private listenToRouter() {
    this.router.events.pipe(
      filter(event => event instanceof ActivationEnd)
    ).subscribe((event: ActivationEnd) =>
      this.store.dispatch(new RouteChangeAction({
        params: { ...event.snapshot.params },
        path: event.snapshot.routeConfig.path
      }))
    );
  }
}
